import { Box, Typography } from "@mui/material";
import useResponsive from "@/hooks/useResponsive";

import Logo from "@/components/UI-Kit/Logo";
import ConfirmationFooter from "./components/ConfirmationFooter";
import {useAppSelector} from "@/redux-store/hooks.ts";
import Cartend from "@/components/Checkout/Confirmation/checkoutEnd.tsx";
import Heading from "@/components/Checkout/components/Heading.tsx";
import { IPaymentResponse } from "../CartSummary/CartSummary";

const OrderSummaryRow = ({ label, value }: { label: string; value: string | number }) => (
    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ margin: "1rem 0" }}>
        <Typography variant="subtitle1" component="p" color="text.primary">{label}</Typography>
        <Typography variant="subtitle1" component="p" color="text.primary">{value}</Typography>
    </Box>
);

const Confirmation = () => {
  const isMobile = useResponsive("down", "sm");
  const paymentResponse = useAppSelector((state) => state.cart.paymentResponse) || {} as IPaymentResponse;
  const newTotalAmount = paymentResponse?.totalAmount % 1 === 0 ? paymentResponse?.totalAmount : paymentResponse?.totalAmount.toFixed(2);
  const newSubTotalAmount = paymentResponse?.subTotalAmount % 1 === 0 ? paymentResponse?.subTotalAmount : paymentResponse?.subTotalAmount.toFixed(2);

  return (
    <Box maxWidth={575} mx="auto" textAlign={{ xs: "start", md: "center" }}>
      <Box py={{ xs: 2.5, md: 4, lg: 5 }} textAlign="center">
        <Logo
          type="dark"
          width={isMobile ? 132 : 204}
          height={isMobile ? 25 : 38}
        />
      </Box>
      <Typography
        variant="h1"
        color="text.primary"
        mb={2}
        fontSize={{ xs: "2rem", md: "2.25rem", lg: "2.5rem" }}
      >
        Your order confirmed!
      </Typography>
        <Typography
            variant="subtitle1"
            component="p"
            color="text.primary"
            mb={{ xs: 3, md: 5 }}
            fontWeight={700}
        >
           Order number
            <Typography
                marginLeft={1}
                variant="subtitle1"
                component="span"
                fontWeight={700}
                color="#FF6B00"
            >
                {paymentResponse?.orderNumber}
            </Typography>
        </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        fontSize="1rem !important"
        color="text.secondary"
        mb={{ xs: 5, md: 4 }}
        padding={{ xs: "0 1rem" }}
      >
          We’ve received your order and it’s being processed.
          You will receive an email confirmation shortly.
      </Typography>


        <Heading title="Order Summary" mb={4} sx={{ textAlign: "start" }} />
        <Cartend paymentResponse={paymentResponse}/>
        <OrderSummaryRow label="Subtotal:" value={`$${newSubTotalAmount}`} />
        <OrderSummaryRow label="Shipping:" value={`$${paymentResponse?.shopShippingMethod?.price ?? 0}`} />
        <OrderSummaryRow label="Tax:" value={`$${paymentResponse?.tax ?? 0}`} />
        <OrderSummaryRow
            label="Discount:"
            value={`%${paymentResponse?.discountApplied?.percentageOff ?? 0}`}
        />
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ margin: "1rem 0" }}>
            <Typography
                variant="h4"
                component="p"
                fontSize={{ xs: "1.125rem", md: "1.25rem" }}
                color="text.primary"
            >
                Amount payed today
            </Typography>
            <Typography
                variant="h4"
                component="p"
                color="text.primary"
            >
                ${newTotalAmount}
            </Typography>
        </Box>
      <ConfirmationFooter />
    </Box>
  );
};

export default Confirmation;
